import styled, { css } from 'styled-components'

const Container = styled.div`
  padding-bottom: 24px;
`

const TabsContainer = styled.div`
  display: flex;
  gap: 4px;
  padding: 4px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  margin-bottom: 30px;
  border: 1px solid rgba(244, 244, 246, 1);
  border-radius: 8px;
  width: fit-content;
`

const Tab = styled.button<{ active?: boolean }>`
  padding: 12px 30px;
  min-width: 118px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ active }) => (active ? '#fff' : 'var(--color-text-black)')};
  background: ${({ active }) => (active ? 'var(--color-button-secondary)' : '#fff')};
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  border-radius: 8px;
  line-height: 21px;
  /* Directional corners so a sole tab (QCS: Admins only) keeps both radii —
     shorthand :last-child would otherwise override :first-child. */
  &:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  &:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }
`

const FiltersRow = styled.div`
  margin-bottom: 20px;
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
`

const RolesSelectWrap = styled.div`
  min-width: 160px;
`

const StatusSelectWrap = styled.div`
  min-width: 162px;
`

const ManagerSelectWrap = styled.div`
  min-width: 174px;
  flex: 0 0 174px;

  @media (max-width: 760px) { flex: 1 1 160px; }
`

interface SpacingProps {
  mt?: number
}

const PaginationSpacer = styled.div<SpacingProps>`
  margin-top: ${({ mt = 14 }) => mt}px;
`

export { Container, TabsContainer, Tab, FiltersRow, RolesSelectWrap, StatusSelectWrap, ManagerSelectWrap, PaginationSpacer }

export const FilterCount = styled.span`
  margin-left: auto;
  color: var(--color-text-secondary);
  font-size: 14px;
  white-space: nowrap;
  strong { color: var(--color-text-black); }
`

export const UserStatusBadge = styled.span<{ $archived?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  color: ${({ $archived }) => ($archived ? 'var(--color-text-secondary)' : '#2e7d32')};
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  white-space: nowrap;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    flex-shrink: 0;
    border-radius: 50%;
    background: ${({ $archived }) => ($archived ? '#888' : '#2e7d32')};
  }
`

// Keep header and body columns aligned, independent of shared table action-column limits.
export const UsersTableLayout = styled.div<{ $isQcs?: boolean }>`
  overflow-x: auto;

  ${({ $isQcs }) => $isQcs && css`
  & > div > div > div > div:not(:last-child) {
    display: grid;
    grid-template-columns: var(--user-columns);
    column-gap: 20px;
    padding-left: 20px;
    padding-right: 20px;
  }
  & > div > div > div > div:not(:last-child) > div {
    max-width: none !important;
    min-width: 0;
    word-break: normal;
    overflow-wrap: anywhere;
  }
  `}
`
